import styles from './PreviewDataDialog.module.css';

import React, { useEffect, useState } from 'react';
import { FormikProvider } from 'formik';

import useTranslation from 'components/hooks/useTranslation';
import QueryResultPreview from 'components/bng/pages/admin/structures/bimQuery/menuTabs/QueryResultPreview';
import Api from 'components/Api';
import UiMsg from 'components/ui/UiMsg';
import useBimContext from 'components/hooks/useBimContext';
import Dialog from 'components/ui/Dialog';
import UiBlocker from 'components/bng/ui/UiBlocker';
import { normalizeFieldDescription } from 'components/bng/pages/admin/structures/bimQuery/BimQueryPage';
import { BngIconButton } from 'components/bng/ui/BngIconButton';

export default function PreviewDataDialog({ closeModal, connectionId, formikValues, nodeId }) {
  const { t } = useTranslation();
  const { project } = useBimContext();

  const [queryResult, setQueryResult] = useState([]);
  const [loading, setLoading] = useState(true);
  const [localFieldConfigs, setLocalFieldConfigs] = useState([]);

  const executePreview = async () => {
    try {
      setLoading(true);
      const response = await Api.BimQuery.executeQuery({
        connectionId: connectionId === 'BIMWarehouse' ? 0 : connectionId,
        sql: formikValues.bimQueryMetadata.tableQueries.find((query) => query.id === nodeId)?.query ?? '',
        fromScheduler: false,
        projectId: project.id,
        pageSize: 25,
      });

      const fields = response.fields.map((f) => ({
        ...f,
        description: normalizeFieldDescription(f.description),
        visibleOnUi: true,
      }));

      setLocalFieldConfigs(fields);
      setQueryResult(response.result || []);
    } catch (e) {
      console.error('Error on executePreview()', e);
      UiMsg.ajaxError(null, e);
      setQueryResult([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!formikValues.bimQueryMetadata.tableQueries) {
      return;
    }
    executePreview();
  }, [nodeId, formikValues.bimQueryMetadata.tableQueries]);

  return (
    <Dialog title={t('data.preview')} className={styles.previewDialog} onClose={closeModal} newDialogLayout>
      <UiBlocker block={loading}>
        <Dialog.Body className={styles.previewBody}>
          <QueryResultPreview style={{ height: '96%' }} queryResult={queryResult} fieldConfigs={localFieldConfigs} />
          <BngIconButton
            className={styles.exportPreviewButton}
            icon={'visibility'}
            text={t('bim.query.export.preview.button.label')}
            onClick={() => {
              bimEventBus.emit(QueryResultPreview.EXPORT_CSV_EVENT);
            }}
          />
        </Dialog.Body>
      </UiBlocker>
    </Dialog>
  );
}
